goog.module('yext.m4.confcode.adminconsole.modal.DeleteModal');

const {SmallDialog} = goog.require('yext.ui.components.modal.Dialog');
goog.require('yext');

/**
 * @fileoverview Component that renders the delete resource confirmation modal
 *
 * @author Alex Politis (apolitis@yext.com)
 */
class DeleteModal extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      showDialog: props.showDialog,
    };
  }

  onHideDialog() {
    this.setState({showDialog: false});
  }

  // TODO (apolitis): If sidebar.js is ever changed to be a react component, pull this code out to
  //                 sidebar.js. The state should just be maintained in sidebar.js
  componentDidUpdate(prevProps) {
    if (prevProps != this.props) {
      this.setState({showDialog: this.props.showDialog});
    }
  }

  render() {
    this.onHideDialog = this.onHideDialog.bind(this);

    const {fileName, resourcesToDelete, onDelete} = this.props;
    const folderIds = resourcesToDelete.directoriesSelected;
    const fileIds = resourcesToDelete.filesSelected;
    const callToAction = {
      primary: {
        type: 'destructive',
        text: yext.msg('Delete'),
        callback: onDelete,
        tid: 'sl-delete-resource',
      },
      cancel: {
        type: 'cancel',
        text: yext.msg('Cancel'),
        tid: 'sl-cancel-delete-resource',
      },
    };

    return (
      <SmallDialog
        title={
          fileName !== undefined
            ? yext.msg('Delete {0}?', fileName)
            : yext.msg('Delete selected resources?')}
        callToAction={callToAction}
        show={this.state.showDialog}
        onHideDialog={this.onHideDialog}
      >
        {fileName !== undefined
          && <p>Are you sure you want to remove {fileName} from your local admin console session?
              Doing so will remove the resource from your Apply.
              Please review the diff for your changes before applying resources.</p>
        }

        {(resourcesToDelete.directoriesSelected.length > 0 || resourcesToDelete.filesSelected.length > 0)
          && <div>
            <p>Are you sure you want to delete the selected resources from your
                local admin console session? Doing so will remove the resource from your Apply.
                Please review the diff for your changes before applying resources.</p>

            <ul className="resources-to-delete-list">
              {folderIds.map(folderId => {
                return <li key={folderId}>{folderId}</li>;
              })}

              {fileIds.map(fileId => {
                return <li key={fileId}>{fileId}</li>;
              })}
            </ul>
          </div>
        }
      </SmallDialog>
    );
  }
}

DeleteModal.propTypes = {
  fileName: PropTypes.string,
  resourcesToDelete: PropTypes.object,
  onClose: PropTypes.func,
  onDelete: PropTypes.func,
};

DeleteModal.defaultProps = {
  fileName: undefined,
  resourcesToDelete: {
    directoriesSelected: {},
    filesSelected: {},
  },
  showDialog: false,
  onClose: () => {},
  onDelete: () => {},
};

DeleteModal['defaultProps'] = DeleteModal.defaultProps;
DeleteModal['propTypes'] = DeleteModal.propTypes;

exports = DeleteModal;
